import React, { useRef, useState } from 'react';
import './Tooltip.css';

type Props = {
    show?: boolean;
    hoverable?: boolean;
    side?: 'top' | 'bottom' | 'right' | 'left' | 'top-right' | 'top-left';
    type?: 'default' | 'error' | 'information' | 'info';
    content?: React.ReactNode;
    className?: string;
    top?: number;
    bottom?: number;
    left?: number;
    right?: number;
    display?: string;
};

const Tooltip: React.FC<React.PropsWithChildren<Props>> = ({
    children,
    content,
    hoverable = false,
    show = true,
    side = 'top',
    type = 'default',
    top,
    bottom,
    left,
    right,
    display = 1,
}) => {
    const [isVisible, setIsVisible] = useState<boolean>(false);

    return (
        <div className='tooltip-parent'
            onMouseEnter={() => hoverable && setIsVisible(true)}
            onMouseLeave={() => hoverable && setIsVisible(false)}
        >
            <div
                className={`tooltip-content tooltip-${type} tooltip-${side} ${isVisible ? 'd-block' : 'd-none'} ${show ? 'd-block' : 'd-none'} ${hoverable ? 'tooltip-hover' : 'tooltip-no-hover'}`}
                style={{
                    top,
                    bottom,
                    left,
                    right,
                    zIndex: display,
                    maxWidth: "300px",
                }}
            >
                {content}
            </div>
            <div>
                {children}
            </div>
        </div>
    );
};

export default Tooltip;
